var template = require('../../templates/settings/PositionItemModal.html');
var ModalFormView = require('commons/views/ModalForm');

module.exports = ModalFormView.extend({
    initialize: function(options) {
        var self = this;

        self.options = _.defaults(options || {}, {
            template: template
        });

        return ModalFormView.prototype.initialize.apply(self, [self.options]);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/PositionItemModal.js